/* eslint-disable @typescript-eslint/no-explicit-any */
import {combineEpics} from 'redux-observable';
import applicationEpics from '@/store/application/epics';
import generalEpics from '@/store/general/epics';

export const epics: any = combineEpics(
    ...applicationEpics,
    ...generalEpics
);